/* eslint-disable */

/**
 * @author Leonel Martinez
 * @fileoverview Set the routing for the app
 */

import Vue from "vue";
import Router from "vue-router";
import { store } from "@/store";
import { ROUTES, hasNestedProperty } from "@/utils";
import i18n from "@/i18n";

Vue.use(Router);

export const router = new Router({
  //mode: "history",  --->>> To use this setting first add the proper server configurations to always redirect all requests to the index.html otherwise the user will see an error.
  routes: [
    {
      path: ROUTES.ROOT,
      redirect: ROUTES.NEW_VEHICLE,
    },
    {
      path: ROUTES.VEHICLE,
      component: () => import("@/pages/Vehicle/Vehicle"),
      children: [
        {
          path: "",
          redirect: ROUTES.NEW_VEHICLE
        },
        {
          name: "new-vehicle",
          path: ROUTES.NEW_VEHICLE,
          component: () => import("@/pages/Vehicle/NewVehicle"),
        },
        {
          name: "recent-vehicles",
          path: ROUTES.RECENT_VEHICLES,
          component: () => import("@/pages/Vehicle/RecentVehicles"),
        }
      ]
    },
    {
      path: ROUTES.CATALOG,
      name: "parts-lookup",
      component: () => import("@/pages/Catalog/Catalog.vue"),
      beforeEnter(to, from, next) {
        /**
         * The catalog lookup requires a YMME selected before being displayed.
         * Gets the user back if no YMME is present.
         */
        store.getters["vehicle/isVehicleSelected"] ? next() : next({ name: "new-vehicle", params: { provider: to.params.provider } });
      }
    },
    {
      path: ROUTES.PARTS_RESULT,
      name: "parts-result",
      component: () => import("@/pages/PartsResult/PartsResult.vue"),
      meta: { title: i18n.tc("PartsResults.Title") },
      beforeEnter(to, from, next) {
        /**
         * If there are interchange results grantee access.
         * Else return him back to the VEHICLE
         */
        if (store.state.parts.groups.length) {
          next();
        } else {
          return next({ name: "new-vehicle", params: { provider: to.params.provider } });
        }
      }
    },
    {
      path: ROUTES.PART_LIST,
      name: "part-list",
      component: () => import("@/pages/PartListResult/PartListResult.vue"),
      meta: { title: i18n.tc("PartsResults.Title") },
      beforeEnter(to, from, next) {
        /**
         * If there are interchange results grantee access.
         * Else return him back to the VEHICLE
         */
        if (store.state.parts.groups.length) {
          next();
        } else {
          return next({ name: "new-vehicle", params: { provider: to.params.provider } });
        }
      }
    },
    {
      path: ROUTES.INTERCHANGE_RESULTS,
      name: "interchange-results",
      component: () => import("@/pages/Interchange/InterchangeResults.vue"),
      meta: { title: i18n.tc("Interchange.TitleResults") },
      beforeEnter(to, from, next) {
        /**
         * If there are interchange results grantee access.
         * Else return him back to the VEHICLE
         */
        if (store.state.interchange.groups.length) {
          next();
        } else {
          return next({ name: "new-vehicle", params: { provider: to.params.provider } });
        }
      }
    },
    {
      path: "/404",
      component: () => import("@/pages/404/404.vue"),
      meta: { title: i18n.tc("404.Title") }
    },
    {
      path: ROUTES.VERSION,
      name: "version",
      component: () => import("@/pages/Version/Version"),
      meta: { title: "Version" }
    },
  ]
});